import React, { Component } from 'react'
import HttpServices from '../../utils/Http.services';
import { checkTranslation, imageAddress, translate } from '../../utils/useful';
import FixedView from '../FixedView'


export default class PortalsSelectApplet extends Component {

    state = {
        fixed: true,
        list: [],
        currentApplet: '',
        currentAppletName: '',
    }

    componentDidMount() {
        let data = {}
        data.features = this.props.type
        let list = this.state.list
        HttpServices.request('getMyAppletsType', data, (fetchResult, fetchError) => {
            if (fetchError) {
                return
            }
            fetchResult.info.map((element, index) => {
                if (element.applet.default) {
                    console.log('element.applet', element.applet)
                    // element.applet.name = (element.appletHub.fullname + '-' + element.applet.features[0])
                    element.applet.name = (element.appletHub.fullname + '-Tasking')
                }
            })
            list = fetchResult.info
            list.unshift({ name: translate('All') })
            let all = translate("All")
            this.setState({ list, currentAppletName: all })
        })
    }

    openAppletView = () => {
        let view = this.state.fixed
        this.setState({ fixed: !view }, () => {
            if (!this.state.fixed) {
                this.appletView.showView()
            }
        })
    };

    onHide = () => {
        let view = this.state.fixed
        this.setState({ fixed: false }, () => {
        })
    };

    changeApplet = (prop) => {
        let currentApplet = this.state.currentApplet
        let currentAppletName = this.state.currentAppletName
        if (!prop?.applet) {
            currentApplet = ''
            currentAppletName = prop.name
        }
        else {
            currentApplet = prop.applet._id
            currentAppletName = prop.applet.name
        }
        this.setState({ currentApplet, currentAppletName }, () => {
            return currentApplet
        })
    }

    render() {
        let { list } = this.state
        let { colors } = this.props

        return (
            <div>
                <button onClick={() => this.showApplets.showView()} ref={el => this.appletssNode = el} className='flexc mrd-2'>
                    <div className={'flexcc pld-3 prd-4 py-1 br-5  ' + (colors?.iconInvert ? "dark-blur-bg" : 'light-blur-bg')}>
                        <div className='flexcc mrd-1'>
                            <img className={colors?.iconInvert ? 'invert' : ''} width={18} src="/assets/icons/applets/database/frame-white.svg" />
                        </div>
                        <p className='font-size-14 ' style={{ color: colors.textColor }}>{checkTranslation(this.props.currentApplet?.name) ?? translate('Applets')}</p>
                    </div>
                </button>
                <FixedView width={this.props.width} zIndex={10} ref={el => this.showApplets = el} nodeRef={this.appletssNode} xOffset={this.props.language == 'fa' ? 170 : -9} bottomOffset={27} topOffset={0} maxWidth={260} >
                    <div className='px-1 bg-white br-10 shadow-3  ' >
                        <div className='px-2 py-1 sc-gray2' style={{ maxHeight: '350px', overflowY: 'scroll' }}>
                            <div className="mt-0">
                                {Array.isArray(list) && list?.map((prop, index) => {
                                    let name = prop?.applet?.name ? prop?.applet?.name : prop.name
                                    return (
                                        <button className='flexc py-2 w-100 bb-gray' onClick={() => this.changeApplet(prop)}>
                                            <div className='mrd-2'>
                                                {name == 'All' ? (
                                                    <img className='br-50' width={25} height={25} src='/assets/icons/messenger/infinity.svg' />
                                                ) : (
                                                    <img className='br-50' width={25} height={25} src={imageAddress(prop.applet?.image, "applet")} />
                                                )}
                                            </div>
                                            <p className='font-size-13 main-c2'>{prop?.applet?.name ? checkTranslation(prop?.applet?.name) : prop.name}</p>
                                        </button>
                                    )
                                })}
                            </div>
                        </div>
                    </div>
                </FixedView>
            </div>
        )
    }
}
